import $ from 'jquery';

const $currency_switch         = $( '[data-currency-switch]' );
let $currency_switch_value     = $currency_switch.val();
const $currency_switch_wrapper = $( '.currency-switch' );
let $style_element             = $( "<style>" ).prop( "type", "text/css" ).appendTo( "head" );

$currency_switch_wrapper.on( 'click', ( e ) => {
	if ( $currency_switch_value === 'show_currency' ) {
		set_local_storage( 'true' );
	}

	if ( $currency_switch_value === 'hide_currency' ) {
		set_local_storage( 'false' );
	}

	update_view( $currency_switch_value );
} );

function update_view( currency_value ) {
	let current_state = localStorage.getItem( 'show_currency' ) ?? 'true';
	let is_visible    = ( current_state === 'true' );

	if ( current_state === 'true' ) {
		$currency_switch_wrapper.addClass( 'active' );
		$currency_switch_wrapper.removeClass( 'not-active' );
		$currency_switch_value = 'hide_currency';
	} else {
		$currency_switch_wrapper.removeClass( 'active' );
		$currency_switch_wrapper.addClass( 'not-active' );
		$currency_switch_value = 'show_currency';
	}

	add_style( is_visible );
}

function set_local_storage( value ) {
	localStorage.setItem( 'show_currency', value );
}

function add_style( is_visible ) {
	let style = ( is_visible ) ? 'flex' : 'none';
	$style_element.html( ".product__price, .part__product__price, .product-detail__actions__price, .product-detail__quantity-prices, .product-detail__wrapper--quantity-prices, .part__product__quantity-prices { display:" + style + "; }" );
}

update_view();